import { render } from "./EquipamentoSetorEditPage.vue?vue&type=template&id=34095e93"
import script from "./EquipamentoSetorEditPage.vue?vue&type=script&lang=js"
export * from "./EquipamentoSetorEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__